import { motion } from "framer-motion";
import { Home, GraduationCap, HeartHandshake, Users, Compass, ShieldCheck } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const ICONS = [Home, GraduationCap, HeartHandshake, Users, Compass, ShieldCheck];

export const Services = () => {
  const { t } = useLanguage();

  return (
    <section id="servizi" data-testid="services-section" className="py-24 lg:py-32 bg-cream">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="text-xs md:text-sm font-semibold uppercase tracking-[0.22em] text-terra mb-6"
        >
          {t.services.eyebrow}
        </motion.p>
        <div className="grid lg:grid-cols-12 gap-8 mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="lg:col-span-6 font-serif font-medium tracking-tight text-ink text-4xl sm:text-5xl lg:text-6xl leading-[1.05]"
          >
            {t.services.title}
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="lg:col-span-5 lg:col-start-8 text-base md:text-lg leading-relaxed text-inksoft self-end"
          >
            {t.services.sub}
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {t.services.items.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={i}
                data-testid={`service-card-${i}`}
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: (i % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
                className="group bg-white border border-line rounded-3xl p-8 hover:-translate-y-1.5 hover:shadow-[0_20px_50px_rgba(200,106,81,0.10)] transition-[transform,box-shadow] duration-300"
              >
                <span className="w-12 h-12 rounded-2xl bg-terra/10 group-hover:bg-terra flex items-center justify-center transition-colors duration-300">
                  <Icon size={22} strokeWidth={1.5} className="text-terra group-hover:text-cream transition-colors duration-300" />
                </span>
                <h3 className="mt-6 font-serif text-2xl font-medium text-ink">{s.title}</h3>
                <p className="mt-3 text-sm md:text-base leading-relaxed text-inksoft">{s.text}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
